/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Action_FlagInputs */

const en_wb_action_flag = /** @type {(inputs: Wb_Action_FlagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flag for a person`)
};

const lv_wb_action_flag = /** @type {(inputs: Wb_Action_FlagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodot cilvēkam`)
};

/**
* | output |
* | --- |
* | "Flag for a person" |
*
* @param {Wb_Action_FlagInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_action_flag = /** @type {((inputs?: Wb_Action_FlagInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Action_FlagInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_action_flag(inputs)
	return en_wb_action_flag(inputs)
});